import { FC } from 'react';
import { Button } from 'antd';
import { PlusOutlined, CalculatorOutlined } from '@ant-design/icons';
import { EmptyStateContainer } from '../EU6Calculator.styles';

interface EmptyStateProps {
  onAddRate: () => void;
}

export const EmptyState: FC<EmptyStateProps> = ({ onAddRate }) => (
  <EmptyStateContainer>
    <CalculatorOutlined className="empty-icon" />
    <div className="empty-title">No rates added yet</div>
    <div className="empty-description">
      Start building your media plan by adding rate cards. Each rate card represents a media buying
      opportunity with specific targeting and costs.
    </div>
    <Button type="primary" size="large" icon={<PlusOutlined />} onClick={onAddRate}>
      Add Your First Rate
    </Button>
  </EmptyStateContainer>
);
